import {take, select, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import creditGeocodedLocation from '../../service-cases/sagas/creditGeocodedLocation';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import * as samaActionTypes from '../samaActionTypes';
import * as serviceAssignmentActionTypes from '../../service-assignments/serviceAssignmentActionTypes';
import config from '../../config';

/**
 * Update SAMA service location flow
 */
const updateSAMAServiceLocationFlow = function* updateSAMAServiceLocationFlow() {
    while (true) {
        const {payload} = yield take(samaActionTypes.SUBMIT_SAMA_SERVICE_LOCATION_FORM);
        const {serviceAssignmentLineNo, serviceAssignmentData, serviceCaseId, serviceCaseData, caseType} = payload;
        const serviceAssignmentId = `${serviceCaseId}-${serviceAssignmentLineNo}`;
        const {serviceAssignments} = yield select(state => state.serviceAssignments);
        const serviceAssignment = serviceAssignments[serviceAssignmentId];

        const isInitialAssignment = serviceAssignment.lineNo === 'FBS1'
            || parseInt(serviceAssignment.lineNo, 10) === 1 || serviceAssignment.isCloneFromInitial;

        yield* updateServiceAssignment({
            caller: serviceAssignmentActionTypes.SUBMIT_RELEVANT_LOCATION_FORM,
            assignmentType: efServiceAssignmentTypes.MEDICAL_ADVICE,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        // credit stored location
        if (!config.IS_FALLBACK_SYSTEM) {
            yield* creditGeocodedLocation({location: serviceAssignmentData.serviceLocation});
        }

        if (isInitialAssignment) {
            yield* updateServiceCase({
                caller: serviceAssignmentActionTypes.SUBMIT_RELEVANT_LOCATION_FORM,
                caseType: caseType,
                serviceCaseId,
                serviceCaseData,
            });
        }

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: serviceAssignmentActionTypes.SUBMIT_RELEVANT_LOCATION_FORM},
        });
    }
};

export default updateSAMAServiceLocationFlow;
